import { jsx as _, jsxs as ee, Fragment as Je } from "react/jsx-runtime";
import { withManagedProps as ce } from "@made-people/managed-props";
import { z as h } from "zod";
import { withZod as ue } from "@made-people/react-prop-guard";
import { shippingBarometerBouncyStepsBlueprint as Qe, shippingBarometerTemplate1Blueprint as Ne } from "./index-blueprint.es.js";
import { motion as R, AnimatePresence as oe } from "motion/react";
import { useCartState as Re } from "@made-people/grease-cart";
import { StickyWrapper as De } from "@made-people/blueprint-sticky-wrapper";
import fe, { useRef as se, useEffect as ve, useState as Ae, useMemo as Be } from "react";
import Xe from "clsx";
import { CheckIcon as et } from "@made-people/blueprint-icons";
import { useTranslate as Le } from "@made-people/grease-translations";
import { twMerge as tt } from "tailwind-merge";
import { useFloating as rt, offset as nt, shift as at, autoUpdate as it } from "@floating-ui/react";
import "@made-people/blueprint";
const ke = h.object({
  content: h.object({}).optional(),
  features: h.object({}).optional(),
  template: h.literal("bouncy-steps"),
  className: h.string().optional(),
  variants: h.custom().optional()
}), ot = ({
  shippingCost: r,
  stepValue: n,
  freeStep: a,
  currentOrderValue: i,
  slots: o
}) => {
  const f = !n[1] || i < n[1], p = i >= n[0], b = f && p, x = n[1] ? n[1] - n[0] : i - n[0], M = (i - n[0]) / x * 100, C = n[1] && i < n[1] ? n[1] - i : 0;
  return /* @__PURE__ */ ee(
    R.div,
    {
      className: o.step,
      layout: !1,
      initial: {
        width: "auto"
      },
      animate: {
        width: b ? 240 : f ? 100 : 20
      },
      exit: {
        width: "auto"
      },
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 30
      },
      children: [
        b && /* @__PURE__ */ _(
          "span",
          {
            className: o.shippingCostBadge,
            children: `Shipping Cost: ${r}`
          }
        ),
        b && /* @__PURE__ */ _(
          R.span,
          {
            transition: {
              duration: 0.3,
              ease: "easeInOut"
            },
            animate: {
              scale: 1,
              opacity: 1
            },
            initial: {
              scale: 0,
              opacity: 0
            },
            exit: {
              scale: 0,
              opacity: 0
            },
            className: "z-10",
            children: a ? "Free" : `${C.toFixed(0)} SEK to next level`
          }
        ),
        p && !b && /* @__PURE__ */ _(
          R.span,
          {
            transition: {
              duration: 0.3,
              ease: "easeInOut"
            },
            animate: {
              scale: 1,
              opacity: 1
            },
            initial: {
              scale: 0,
              opacity: 0
            },
            exit: {
              scale: 0,
              opacity: 0
            },
            className: "z-10",
            children: /* @__PURE__ */ _(
              R.svg,
              {
                viewBox: "0 0 44 44",
                width: "20px",
                height: "20px",
                display: "block",
                className: "stroke-theme-black",
                fill: "none",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                opacity: "1",
                stroke: "black",
                initial: {
                  opacity: 0,
                  pathLength: 1,
                  strokeDashoffset: 124.6,
                  strokeDasharray: "0, 162.6, 30, 132.6"
                },
                animate: {
                  opacity: 1,
                  pathLength: 1,
                  strokeDashoffset: 162.6,
                  strokeDasharray: "0, 162.6, 28, 134.6"
                },
                transition: {
                  delay: 0.3,
                  type: "tween",
                  duration: 0.3
                },
                children: /* @__PURE__ */ _(
                  "path",
                  {
                    d: "M14,24 L21,31 L39.7428882,11.5937758 C35.2809627,6.53125861 30.0333333,4 24,4 C12.95,4 4,12.95 4,24 C4,35.05 12.95,44 24,44 C35.05,44 44,35.05 44,24 C44,19.3 42.5809627,15.1645919 39.7428882,11.5937758",
                    transform: "translate(-2.000000, -2.000000)"
                  }
                )
              }
            )
          }
        ),
        !p && !b && /* @__PURE__ */ _(
          R.span,
          {
            transition: {
              duration: 0.3,
              ease: "easeInOut"
            },
            animate: {
              scale: 1,
              opacity: 1
            },
            initial: {
              scale: 0,
              opacity: 0
            },
            exit: {
              scale: 0,
              opacity: 0
            },
            className: "z-10",
            children: a ? "Free 🎉" : `${n[0]} SEK`
          }
        ),
        /* @__PURE__ */ _(
          R.div,
          {
            animate: {
              width: b ? a ? "100%" : `${M}%` : p ? "100%" : "0%"
            },
            transition: {
              type: "spring",
              stiffness: 300,
              damping: 30
            },
            className: o.stepProgress
          }
        )
      ]
    }
  );
}, Fe = [
  {
    shippingCost: "210 SEK",
    stepValue: [0, 100]
  },
  {
    shippingCost: "170 SEK",
    stepValue: [100, 350]
  },
  {
    shippingCost: "90 SEK",
    stepValue: [350, 750]
  },
  {
    shippingCost: "Free 🎉",
    freeStep: !0,
    stepValue: [750]
  }
], st = ce(
  "ShippingBarometerAsBouncySteps",
  ue(
    ke,
    ({ variants: r, content: n = {}, features: a = {} }) => {
      var M, C;
      const i = Qe.styles(r), { cart: o } = Re();
      if (!o)
        return null;
      const { totals: f } = o;
      if (!f)
        return null;
      const { grandTotal: p } = f, b = (C = (M = Fe.filter(
        (w) => w.freeStep
      )[0]) == null ? void 0 : M.stepValue) == null ? void 0 : C[0], x = b && p.number >= b;
      return /* @__PURE__ */ _(De, { className: i.base, children: /* @__PURE__ */ _(R.div, { className: i.content, children: /* @__PURE__ */ _(oe, { initial: !1, mode: "wait", children: x ? /* @__PURE__ */ _(
        R.div,
        {
          className: i.freeShipping,
          layout: !1,
          initial: {
            width: "auto",
            opacity: 0
          },
          animate: { opacity: 1, width: "100%" },
          exit: {
            width: "auto",
            opacity: 0
          },
          transition: {
            type: "spring",
            stiffness: 300,
            damping: 30
          },
          children: "🎉You have free shipping! 🎉"
        },
        "free-shipping"
      ) : Fe.map((w, K) => /* @__PURE__ */ _(
        ot,
        {
          shippingCost: w.shippingCost,
          stepValue: w.stepValue,
          currentOrderValue: p.number,
          slots: i,
          freeStep: w.freeStep
        },
        K
      )) }) }) });
    }
  )
), lt = h.object({
  variants: h.custom().optional(),
  className: h.string().optional(),
  shippingCost: h.string(),
  isCompleted: h.boolean(),
  isActive: h.boolean(),
  label: h.string().optional(),
  icons: h.object({
    stepCompleted: h.custom().optional()
  }).optional(),
  shippingMethod: h.string(),
  setReference: h.function().args(h.any()).returns(h.void()).optional(),
  width: h.number().optional()
}), ct = ({
  variants: r,
  className: n,
  isActive: a,
  isCompleted: i,
  shippingCost: o,
  label: f,
  icons: p,
  shippingMethod: b,
  setReference: x,
  width: M = 0
}) => {
  Le();
  const C = Ne.styles(r), w = se(!1);
  return ve(() => {
    w.current = !0;
  }, []), /* @__PURE__ */ _(
    R.div,
    {
      className: tt(
        C.step,
        a ? C.stepActive : "",
        i ? C.stepCompleted : ""
      ),
      style: { width: M },
      initial: !1,
      animate: w.current ? { width: M } : {},
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 10,
        mass: 0.4
      },
      children: /* @__PURE__ */ ee("span", { className: C.stepLabel, children: [
        !i && f,
        i && /* @__PURE__ */ _("span", { className: C.stepCompletedIcon, children: p == null ? void 0 : p.stepCompleted })
      ] })
    }
  );
}, ut = fe.memo(
  ce(
    "Shipping_Barometer_Template1_Step",
    ue(lt, ct)
  )
), ft = h.object({
  shippingPrice: h.number(),
  requiredCartAmount: h.number()
}), pt = h.object({
  name: h.string(),
  tiers: h.array(ft)
});
var g = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function dt(r) {
  if (r.__esModule)
    return r;
  var n = r.default;
  if (typeof n == "function") {
    var a = function i() {
      return this instanceof i ? Reflect.construct(n, arguments, this.constructor) : n.apply(this, arguments);
    };
    a.prototype = n.prototype;
  } else
    a = {};
  return Object.defineProperty(a, "__esModule", { value: !0 }), Object.keys(r).forEach(function(i) {
    var o = Object.getOwnPropertyDescriptor(r, i);
    Object.defineProperty(a, i, o.get ? o : {
      enumerable: !0,
      get: function() {
        return r[i];
      }
    });
  }), a;
}
var $e = {}, be = {}, _e = {}, Me = {};
(function r(n, a, i, o) {
  var f = !!(n.Worker && n.Blob && n.Promise && n.OffscreenCanvas && n.OffscreenCanvasRenderingContext2D && n.HTMLCanvasElement && n.HTMLCanvasElement.prototype.transferControlToOffscreen && n.URL && n.URL.createObjectURL), p = typeof Path2D == "function" && typeof DOMMatrix == "function", b = function() {
    if (!n.OffscreenCanvas)
      return !1;
    try {
      var t = new OffscreenCanvas(1, 1), e = t.getContext("2d");
      e.fillRect(0, 0, 1, 1);
      var s = t.transferToImageBitmap();
      e.createPattern(s, "no-repeat");
    } catch {
      return !1;
    }
    return !0;
  }();
  function x() {
  }
  function M(t) {
    var e = a.exports.Promise, s = e !== void 0 ? e : n.Promise;
    return typeof s == "function" ? new s(t) : (t(x, x), null);
  }
  var C = function(t, e) {
    return {
      transform: function(s) {
        if (t)
          return s;
        if (e.has(s))
          return e.get(s);
        var l = new OffscreenCanvas(s.width, s.height), u = l.getContext("2d");
        return u.drawImage(s, 0, 0), e.set(s, l), l;
      },
      clear: function() {
        e.clear();
      }
    };
  }(b, /* @__PURE__ */ new Map()), w = function() {
    var t = Math.floor(16.666666666666668), e, s, l = {}, u = 0;
    return typeof requestAnimationFrame == "function" && typeof cancelAnimationFrame == "function" ? (e = function(d) {
      var m = Math.random();
      return l[m] = requestAnimationFrame(function c(v) {
        u === v || u + t - 1 < v ? (u = v, delete l[m], d()) : l[m] = requestAnimationFrame(c);
      }), m;
    }, s = function(d) {
      l[d] && cancelAnimationFrame(l[d]);
    }) : (e = function(d) {
      return setTimeout(d, t);
    }, s = function(d) {
      return clearTimeout(d);
    }), { frame: e, cancel: s };
  }(), K = function() {
    var t, e, s = {};
    function l(u) {
      function d(m, c) {
        u.postMessage({ options: m || {}, callback: c });
      }
      u.init = function(c) {
        var v = c.transferControlToOffscreen();
        u.postMessage({ canvas: v }, [v]);
      }, u.fire = function(c, v, S) {
        if (e)
          return d(c, null), e;
        var I = Math.random().toString(36).slice(2);
        return e = M(function(O) {
          function j(F) {
            F.data.callback === I && (delete s[I], u.removeEventListener("message", j), e = null, C.clear(), S(), O());
          }
          u.addEventListener("message", j), d(c, I), s[I] = j.bind(null, { data: { callback: I } });
        }), e;
      }, u.reset = function() {
        u.postMessage({ reset: !0 });
        for (var c in s)
          s[c](), delete s[c];
      };
    }
    return function() {
      if (t)
        return t;
      if (!i && f) {
        var u = [
          "var CONFETTI, SIZE = {}, module = {};",
          "(" + r.toString() + ")(this, module, true, SIZE);",
          "onmessage = function(msg) {",
          "  if (msg.data.options) {",
          "    CONFETTI(msg.data.options).then(function () {",
          "      if (msg.data.callback) {",
          "        postMessage({ callback: msg.data.callback });",
          "      }",
          "    });",
          "  } else if (msg.data.reset) {",
          "    CONFETTI && CONFETTI.reset();",
          "  } else if (msg.data.resize) {",
          "    SIZE.width = msg.data.resize.width;",
          "    SIZE.height = msg.data.resize.height;",
          "  } else if (msg.data.canvas) {",
          "    SIZE.width = msg.data.canvas.width;",
          "    SIZE.height = msg.data.canvas.height;",
          "    CONFETTI = module.exports.create(msg.data.canvas);",
          "  }",
          "}"
        ].join(`
`);
        try {
          t = new Worker(URL.createObjectURL(new Blob([u])));
        } catch (d) {
          return typeof console < "u" && typeof console.warn == "function" && console.warn("🎊 Could not load worker", d), null;
        }
        l(t);
      }
      return t;
    };
  }(), Pe = {
    particleCount: 50,
    angle: 90,
    spread: 45,
    startVelocity: 45,
    decay: 0.9,
    gravity: 1,
    drift: 0,
    ticks: 200,
    x: 0.5,
    y: 0.5,
    shapes: ["square", "circle"],
    zIndex: 100,
    colors: [
      "#26ccff",
      "#a25afd",
      "#ff5e7e",
      "#88ff5a",
      "#fcff42",
      "#ffa62d",
      "#ff36ff"
    ],
    // probably should be true, but back-compat
    disableForReducedMotion: !1,
    scalar: 1
  };
  function J(t, e) {
    return e ? e(t) : t;
  }
  function k(t) {
    return t != null;
  }
  function T(t, e, s) {
    return J(
      t && k(t[e]) ? t[e] : Pe[e],
      s
    );
  }
  function te(t) {
    return t < 0 ? 0 : Math.floor(t);
  }
  function re(t, e) {
    return Math.floor(Math.random() * (e - t)) + t;
  }
  function V(t) {
    return parseInt(t, 16);
  }
  function Q(t) {
    return t.map(pe);
  }
  function pe(t) {
    var e = String(t).replace(/[^0-9a-f]/gi, "");
    return e.length < 6 && (e = e[0] + e[0] + e[1] + e[1] + e[2] + e[2]), {
      r: V(e.substring(0, 2)),
      g: V(e.substring(2, 4)),
      b: V(e.substring(4, 6))
    };
  }
  function G(t) {
    var e = T(t, "origin", Object);
    return e.x = T(e, "x", Number), e.y = T(e, "y", Number), e;
  }
  function X(t) {
    t.width = document.documentElement.clientWidth, t.height = document.documentElement.clientHeight;
  }
  function ne(t) {
    var e = t.getBoundingClientRect();
    t.width = e.width, t.height = e.height;
  }
  function de(t) {
    var e = document.createElement("canvas");
    return e.style.position = "fixed", e.style.top = "0px", e.style.left = "0px", e.style.pointerEvents = "none", e.style.zIndex = t, e;
  }
  function $(t, e, s, l, u, d, m, c, v) {
    t.save(), t.translate(e, s), t.rotate(d), t.scale(l, u), t.arc(0, 0, 1, m, c, v), t.restore();
  }
  function E(t) {
    var e = t.angle * (Math.PI / 180), s = t.spread * (Math.PI / 180);
    return {
      x: t.x,
      y: t.y,
      wobble: Math.random() * 10,
      wobbleSpeed: Math.min(0.11, Math.random() * 0.1 + 0.05),
      velocity: t.startVelocity * 0.5 + Math.random() * t.startVelocity,
      angle2D: -e + (0.5 * s - Math.random() * s),
      tiltAngle: (Math.random() * (0.75 - 0.25) + 0.25) * Math.PI,
      color: t.color,
      shape: t.shape,
      tick: 0,
      totalTicks: t.ticks,
      decay: t.decay,
      drift: t.drift,
      random: Math.random() + 2,
      tiltSin: 0,
      tiltCos: 0,
      wobbleX: 0,
      wobbleY: 0,
      gravity: t.gravity * 3,
      ovalScalar: 0.6,
      scalar: t.scalar,
      flat: t.flat
    };
  }
  function Y(t, e) {
    e.x += Math.cos(e.angle2D) * e.velocity + e.drift, e.y += Math.sin(e.angle2D) * e.velocity + e.gravity, e.velocity *= e.decay, e.flat ? (e.wobble = 0, e.wobbleX = e.x + 10 * e.scalar, e.wobbleY = e.y + 10 * e.scalar, e.tiltSin = 0, e.tiltCos = 0, e.random = 1) : (e.wobble += e.wobbleSpeed, e.wobbleX = e.x + 10 * e.scalar * Math.cos(e.wobble), e.wobbleY = e.y + 10 * e.scalar * Math.sin(e.wobble), e.tiltAngle += 0.1, e.tiltSin = Math.sin(e.tiltAngle), e.tiltCos = Math.cos(e.tiltAngle), e.random = Math.random() + 2);
    var s = e.tick++ / e.totalTicks, l = e.x + e.random * e.tiltCos, u = e.y + e.random * e.tiltSin, d = e.wobbleX + e.random * e.tiltCos, m = e.wobbleY + e.random * e.tiltSin;
    if (t.fillStyle = "rgba(" + e.color.r + ", " + e.color.g + ", " + e.color.b + ", " + (1 - s) + ")", t.beginPath(), p && e.shape.type === "path" && typeof e.shape.path == "string" && Array.isArray(e.shape.matrix))
      t.fill(q(
        e.shape.path,
        e.shape.matrix,
        e.x,
        e.y,
        Math.abs(d - l) * 0.1,
        Math.abs(m - u) * 0.1,
        Math.PI / 10 * e.wobble
      ));
    else if (e.shape.type === "bitmap") {
      var c = Math.PI / 10 * e.wobble, v = Math.abs(d - l) * 0.1, S = Math.abs(m - u) * 0.1, I = e.shape.bitmap.width * e.scalar, O = e.shape.bitmap.height * e.scalar, j = new DOMMatrix([
        Math.cos(c) * v,
        Math.sin(c) * v,
        -Math.sin(c) * S,
        Math.cos(c) * S,
        e.x,
        e.y
      ]);
      j.multiplySelf(new DOMMatrix(e.shape.matrix));
      var F = t.createPattern(C.transform(e.shape.bitmap), "no-repeat");
      F.setTransform(j), t.globalAlpha = 1 - s, t.fillStyle = F, t.fillRect(
        e.x - I / 2,
        e.y - O / 2,
        I,
        O
      ), t.globalAlpha = 1;
    } else if (e.shape === "circle")
      t.ellipse ? t.ellipse(e.x, e.y, Math.abs(d - l) * e.ovalScalar, Math.abs(m - u) * e.ovalScalar, Math.PI / 10 * e.wobble, 0, 2 * Math.PI) : $(t, e.x, e.y, Math.abs(d - l) * e.ovalScalar, Math.abs(m - u) * e.ovalScalar, Math.PI / 10 * e.wobble, 0, 2 * Math.PI);
    else if (e.shape === "star")
      for (var y = Math.PI / 2 * 3, N = 4 * e.scalar, D = 8 * e.scalar, L = e.x, U = e.y, H = 5, W = Math.PI / H; H--; )
        L = e.x + Math.cos(y) * D, U = e.y + Math.sin(y) * D, t.lineTo(L, U), y += W, L = e.x + Math.cos(y) * N, U = e.y + Math.sin(y) * N, t.lineTo(L, U), y += W;
    else
      t.moveTo(Math.floor(e.x), Math.floor(e.y)), t.lineTo(Math.floor(e.wobbleX), Math.floor(u)), t.lineTo(Math.floor(d), Math.floor(m)), t.lineTo(Math.floor(l), Math.floor(e.wobbleY));
    return t.closePath(), t.fill(), e.tick < e.totalTicks;
  }
  function he(t, e, s, l, u) {
    var d = e.slice(), m = t.getContext("2d"), c, v, S = M(function(I) {
      function O() {
        c = v = null, m.clearRect(0, 0, l.width, l.height), C.clear(), u(), I();
      }
      function j() {
        i && !(l.width === o.width && l.height === o.height) && (l.width = t.width = o.width, l.height = t.height = o.height), !l.width && !l.height && (s(t), l.width = t.width, l.height = t.height), m.clearRect(0, 0, l.width, l.height), d = d.filter(function(F) {
          return Y(m, F);
        }), d.length ? c = w.frame(j) : O();
      }
      c = w.frame(j), v = O;
    });
    return {
      addFettis: function(I) {
        return d = d.concat(I), S;
      },
      canvas: t,
      promise: S,
      reset: function() {
        c && w.cancel(c), v && v();
      }
    };
  }
  function P(t, e) {
    var s = !t, l = !!T(e || {}, "resize"), u = !1, d = T(e, "disableForReducedMotion", Boolean), m = f && !!T(e || {}, "useWorker"), c = m ? K() : null, v = s ? X : ne, S = t && c ? !!t.__confetti_initialized : !1, I = typeof matchMedia == "function" && matchMedia("(prefers-reduced-motion)").matches, O;
    function j(y, N, D) {
      for (var L = T(y, "particleCount", te), U = T(y, "angle", Number), H = T(y, "spread", Number), W = T(y, "startVelocity", Number), We = T(y, "decay", Number), Ue = T(y, "gravity", Number), Ze = T(y, "drift", Number), xe = T(y, "colors", Q), Ke = T(y, "ticks", Number), Te = T(y, "shapes"), Ve = T(y, "scalar"), He = !!T(y, "flat"), Ie = G(y), je = L, me = [], Ge = t.width * Ie.x, Ye = t.height * Ie.y; je--; )
        me.push(
          E({
            x: Ge,
            y: Ye,
            angle: U,
            spread: H,
            startVelocity: W,
            color: xe[je % xe.length],
            shape: Te[re(0, Te.length)],
            ticks: Ke,
            decay: We,
            gravity: Ue,
            drift: Ze,
            scalar: Ve,
            flat: He
          })
        );
      return O ? O.addFettis(me) : (O = he(t, me, v, N, D), O.promise);
    }
    function F(y) {
      var N = d || T(y, "disableForReducedMotion", Boolean), D = T(y, "zIndex", Number);
      if (N && I)
        return M(function(W) {
          W();
        });
      s && O ? t = O.canvas : s && !t && (t = de(D), document.body.appendChild(t)), l && !S && v(t);
      var L = {
        width: t.width,
        height: t.height
      };
      c && !S && c.init(t), S = !0, c && (t.__confetti_initialized = !0);
      function U() {
        if (c) {
          var W = {
            getBoundingClientRect: function() {
              if (!s)
                return t.getBoundingClientRect();
            }
          };
          v(W), c.postMessage({
            resize: {
              width: W.width,
              height: W.height
            }
          });
          return;
        }
        L.width = L.height = null;
      }
      function H() {
        O = null, l && (u = !1, n.removeEventListener("resize", U)), s && t && (document.body.contains(t) && document.body.removeChild(t), t = null, S = !1);
      }
      return l && !u && (u = !0, n.addEventListener("resize", U, !1)), c ? c.fire(y, L, H) : j(y, L, H);
    }
    return F.reset = function() {
      c && c.reset(), O && O.reset();
    }, F;
  }
  var A;
  function B() {
    return A || (A = P(null, { useWorker: !0, resize: !0 })), A;
  }
  function q(t, e, s, l, u, d, m) {
    var c = new Path2D(t), v = new Path2D();
    v.addPath(c, new DOMMatrix(e));
    var S = new Path2D();
    return S.addPath(v, new DOMMatrix([
      Math.cos(m) * u,
      Math.sin(m) * u,
      -Math.sin(m) * d,
      Math.cos(m) * d,
      s,
      l
    ])), S;
  }
  function z(t) {
    if (!p)
      throw new Error("path confetti are not supported in this browser");
    var e, s;
    typeof t == "string" ? e = t : (e = t.path, s = t.matrix);
    var l = new Path2D(e), u = document.createElement("canvas"), d = u.getContext("2d");
    if (!s) {
      for (var m = 1e3, c = m, v = m, S = 0, I = 0, O, j, F = 0; F < m; F += 2)
        for (var y = 0; y < m; y += 2)
          d.isPointInPath(l, F, y, "nonzero") && (c = Math.min(c, F), v = Math.min(v, y), S = Math.max(S, F), I = Math.max(I, y));
      O = S - c, j = I - v;
      var N = 10, D = Math.min(N / O, N / j);
      s = [
        D,
        0,
        0,
        D,
        -Math.round(O / 2 + c) * D,
        -Math.round(j / 2 + v) * D
      ];
    }
    return {
      type: "path",
      path: e,
      matrix: s
    };
  }
  function Z(t) {
    var e, s = 1, l = "#000000", u = '"Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji", "EmojiOne Color", "Android Emoji", "Twemoji Mozilla", "system emoji", sans-serif';
    typeof t == "string" ? e = t : (e = t.text, s = "scalar" in t ? t.scalar : s, u = "fontFamily" in t ? t.fontFamily : u, l = "color" in t ? t.color : l);
    var d = 10 * s, m = "" + d + "px " + u, c = new OffscreenCanvas(d, d), v = c.getContext("2d");
    v.font = m;
    var S = v.measureText(e), I = Math.ceil(S.actualBoundingBoxRight + S.actualBoundingBoxLeft), O = Math.ceil(S.actualBoundingBoxAscent + S.actualBoundingBoxDescent), j = 2, F = S.actualBoundingBoxLeft + j, y = S.actualBoundingBoxAscent + j;
    I += j + j, O += j + j, c = new OffscreenCanvas(I, O), v = c.getContext("2d"), v.font = m, v.fillStyle = l, v.fillText(e, F, y);
    var N = 1 / s;
    return {
      type: "bitmap",
      // TODO these probably need to be transfered for workers
      bitmap: c.transferToImageBitmap(),
      matrix: [N, 0, 0, N, -I * N / 2, -O * N / 2]
    };
  }
  a.exports = function() {
    return B().apply(this, arguments);
  }, a.exports.reset = function() {
    B().reset();
  }, a.exports.create = P, a.exports.shapeFromPath = z, a.exports.shapeFromText = Z;
})(function() {
  return typeof window < "u" ? window : typeof self < "u" ? self : this || {};
}(), Me, !1);
const ht = Me.exports;
var mt = Me.exports.create;
const vt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  create: mt,
  default: ht
}, Symbol.toStringTag, { value: "Module" })), gt = /* @__PURE__ */ dt(vt);
var le = g && g.__assign || function() {
  return le = Object.assign || function(r) {
    for (var n, a = 1, i = arguments.length; a < i; a++) {
      n = arguments[a];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (r[o] = n[o]);
    }
    return r;
  }, le.apply(this, arguments);
}, yt = g && g.__createBinding || (Object.create ? function(r, n, a, i) {
  i === void 0 && (i = a);
  var o = Object.getOwnPropertyDescriptor(n, a);
  (!o || ("get" in o ? !n.__esModule : o.writable || o.configurable)) && (o = { enumerable: !0, get: function() {
    return n[a];
  } }), Object.defineProperty(r, i, o);
} : function(r, n, a, i) {
  i === void 0 && (i = a), r[i] = n[a];
}), bt = g && g.__setModuleDefault || (Object.create ? function(r, n) {
  Object.defineProperty(r, "default", { enumerable: !0, value: n });
} : function(r, n) {
  r.default = n;
}), _t = g && g.__importStar || function(r) {
  if (r && r.__esModule)
    return r;
  var n = {};
  if (r != null)
    for (var a in r)
      a !== "default" && Object.prototype.hasOwnProperty.call(r, a) && yt(n, r, a);
  return bt(n, r), n;
}, Mt = g && g.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
};
Object.defineProperty(_e, "__esModule", { value: !0 });
var ae = _t(fe), wt = Mt(gt), Ct = {
  resize: !0,
  useWorker: !1
}, St = {
  position: "fixed",
  pointerEvents: "none",
  width: "100%",
  height: "100%",
  top: 0,
  left: 0
};
function Ot(r, n) {
  return !r && !n ? St : r;
}
function Pt(r) {
  var n = r.style, a = r.className, i = r.width, o = r.height, f = r.globalOptions, p = r.onInit, b = (0, ae.useRef)(null), x = (0, ae.useRef)(null);
  return (0, ae.useEffect)(function() {
    if (b.current)
      return x.current = wt.default.create(b.current, le(le({}, Ct), f)), p == null || p({ confetti: x.current }), function() {
        var M;
        (M = x.current) === null || M === void 0 || M.reset();
      };
  }, []), ae.default.createElement("canvas", { ref: b, style: Ot(n, a), className: a, width: i, height: o });
}
_e.default = Pt;
var ge = g && g.__assign || function() {
  return ge = Object.assign || function(r) {
    for (var n, a = 1, i = arguments.length; a < i; a++) {
      n = arguments[a];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (r[o] = n[o]);
    }
    return r;
  }, ge.apply(this, arguments);
}, xt = g && g.__createBinding || (Object.create ? function(r, n, a, i) {
  i === void 0 && (i = a);
  var o = Object.getOwnPropertyDescriptor(n, a);
  (!o || ("get" in o ? !n.__esModule : o.writable || o.configurable)) && (o = { enumerable: !0, get: function() {
    return n[a];
  } }), Object.defineProperty(r, i, o);
} : function(r, n, a, i) {
  i === void 0 && (i = a), r[i] = n[a];
}), Tt = g && g.__setModuleDefault || (Object.create ? function(r, n) {
  Object.defineProperty(r, "default", { enumerable: !0, value: n });
} : function(r, n) {
  r.default = n;
}), It = g && g.__importStar || function(r) {
  if (r && r.__esModule)
    return r;
  var n = {};
  if (r != null)
    for (var a in r)
      a !== "default" && Object.prototype.hasOwnProperty.call(r, a) && xt(n, r, a);
  return Tt(n, r), n;
}, jt = g && g.__rest || function(r, n) {
  var a = {};
  for (var i in r)
    Object.prototype.hasOwnProperty.call(r, i) && n.indexOf(i) < 0 && (a[i] = r[i]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, i = Object.getOwnPropertySymbols(r); o < i.length; o++)
      n.indexOf(i[o]) < 0 && Object.prototype.propertyIsEnumerable.call(r, i[o]) && (a[i[o]] = r[i[o]]);
  return a;
}, At = g && g.__read || function(r, n) {
  var a = typeof Symbol == "function" && r[Symbol.iterator];
  if (!a)
    return r;
  var i = a.call(r), o, f = [], p;
  try {
    for (; (n === void 0 || n-- > 0) && !(o = i.next()).done; )
      f.push(o.value);
  } catch (b) {
    p = { error: b };
  } finally {
    try {
      o && !o.done && (a = i.return) && a.call(i);
    } finally {
      if (p)
        throw p.error;
    }
  }
  return f;
}, Bt = g && g.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
};
Object.defineProperty(be, "__esModule", { value: !0 });
var ie = It(fe), Ft = Bt(_e), Et = function(r) {
  return r;
};
function Nt(r) {
  var n = r.decorateOptions, a = n === void 0 ? Et : n, i = r.Conductor, o = r.autorun, f = r.onInit, p = jt(r, ["decorateOptions", "Conductor", "autorun", "onInit"]), b = At((0, ie.useState)(), 2), x = b[0], M = b[1], C = (0, ie.useCallback)(function(w) {
    var K = w.confetti;
    M(function() {
      return K;
    });
  }, []);
  return (0, ie.useEffect)(function() {
    if (x) {
      var w = new i({
        confetti: x,
        decorateOptions: a
      });
      return o && w.run(o), f == null || f({ confetti: x, conductor: w }), w.stop;
    }
  }, [x]), ie.default.createElement(Ft.default, ge({ onInit: C }, p));
}
be.default = Nt;
var we = {}, Ce = {};
Object.defineProperty(Ce, "__esModule", { value: !0 });
var Rt = function() {
  function r(n) {
    var a = n.confetti, i = n.decorateOptions, o = this;
    this.interval = null, this.shoot = function() {
      return o.tickAnimation();
    }, this.run = function(f) {
      var p = f.speed, b = f.delay, x = b === void 0 ? 0 : b, M = f.duration;
      o.interval || setTimeout(function() {
        o.shoot(), o.interval = setInterval(o.shoot, 1e3 / Math.min(p, 1e3)), M && setTimeout(o.pause, M);
      }, x);
    }, this.pause = function() {
      clearInterval(o.interval), o.interval = null;
    }, this.stop = function() {
      o.pause(), o.confetti.reset();
    }, this.confetti = a, this.decorateOptions = i;
  }
  return r;
}();
Ce.default = Rt;
var Se = {};
Object.defineProperty(Se, "__esModule", { value: !0 });
function Dt(r, n) {
  return Math.random() * (n - r) + r;
}
Se.default = Dt;
var Lt = g && g.__extends || function() {
  var r = function(n, a) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(i, o) {
      i.__proto__ = o;
    } || function(i, o) {
      for (var f in o)
        Object.prototype.hasOwnProperty.call(o, f) && (i[f] = o[f]);
    }, r(n, a);
  };
  return function(n, a) {
    if (typeof a != "function" && a !== null)
      throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
    r(n, a);
    function i() {
      this.constructor = n;
    }
    n.prototype = a === null ? Object.create(a) : (i.prototype = a.prototype, new i());
  };
}(), kt = g && g.__read || function(r, n) {
  var a = typeof Symbol == "function" && r[Symbol.iterator];
  if (!a)
    return r;
  var i = a.call(r), o, f = [], p;
  try {
    for (; (n === void 0 || n-- > 0) && !(o = i.next()).done; )
      f.push(o.value);
  } catch (b) {
    p = { error: b };
  } finally {
    try {
      o && !o.done && (a = i.return) && a.call(i);
    } finally {
      if (p)
        throw p.error;
    }
  }
  return f;
}, $t = g && g.__spreadArray || function(r, n, a) {
  if (a || arguments.length === 2)
    for (var i = 0, o = n.length, f; i < o; i++)
      (f || !(i in n)) && (f || (f = Array.prototype.slice.call(n, 0, i)), f[i] = n[i]);
  return r.concat(f || Array.prototype.slice.call(n));
}, qe = g && g.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
};
Object.defineProperty(we, "__esModule", { value: !0 });
var qt = qe(Ce), Ee = qe(Se), zt = function(r) {
  Lt(n, r);
  function n() {
    var a = r.apply(this, $t([], kt(arguments), !1)) || this;
    return a.tickAnimation = function() {
      a.confetti(a.decorateOptions({
        startVelocity: 30,
        spread: 360,
        ticks: 60,
        zIndex: 0,
        particleCount: 150,
        origin: {
          x: (0, Ee.default)(0.1, 0.3),
          y: Math.random() - 0.2
        }
      })), a.confetti(a.decorateOptions({
        startVelocity: 30,
        spread: 360,
        ticks: 60,
        zIndex: 0,
        particleCount: 150,
        origin: {
          x: (0, Ee.default)(0.7, 0.9),
          y: Math.random() - 0.2
        }
      }));
    }, a;
  }
  return n;
}(qt.default);
we.default = zt;
var ye = g && g.__assign || function() {
  return ye = Object.assign || function(r) {
    for (var n, a = 1, i = arguments.length; a < i; a++) {
      n = arguments[a];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (r[o] = n[o]);
    }
    return r;
  }, ye.apply(this, arguments);
}, Oe = g && g.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
};
Object.defineProperty($e, "__esModule", { value: !0 });
var Wt = Oe(fe), Ut = Oe(be), Zt = Oe(we);
function Kt(r) {
  return Wt.default.createElement(Ut.default, ye({ Conductor: Zt.default }, r));
}
var Vt = $e.default = Kt;
const ze = h.object({
  template: h.literal("template1").optional(),
  variants: h.custom().optional(),
  enabled: h.boolean().optional(),
  className: h.string().optional(),
  icons: h.object({
    stepCompleted: h.custom().optional()
  }).optional(),
  priceFormatter: h.function().args(h.number()).returns(h.string()).optional(),
  shippingOption: pt.optional(),
  showConfettiIfShippingIsFree: h.boolean().optional()
}), Ht = ce(
  "ShippingBarometerTemplate1",
  ue(
    {
      schema: ze,
      defaultProps: {
        enabled: !1,
        icons: { stepCompleted: /* @__PURE__ */ _(et, {}) },
        showConfettiIfShippingIsFree: !1
      }
    },
    ({
      variants: r,
      className: n,
      icons: a,
      shippingOption: i,
      showConfettiIfShippingIsFree: o,
      priceFormatter: f = (p) => p.toString()
    }) => {
      const p = Ne.styles(r), b = Le(), { cart: x } = Re(), M = x == null ? void 0 : x.totals, C = M == null ? void 0 : M.grandTotal, w = M == null ? void 0 : M.shipping, K = typeof (C == null ? void 0 : C.number) == "number" && typeof (w == null ? void 0 : w.number) == "number";
      if (!x || !M || !i || !K)
        return null;
      const J = i.tiers.find((P) => P.shippingPrice === 0), k = !!J && C.number - w.number >= J.requiredCartAmount, [T, te] = Ae(!1), re = se(!1), V = se(!1);
      ve(() => {
        if (!re.current) {
          re.current = !0, V.current = k;
          return;
        }
        !V.current && k && o && (te(!0), setTimeout(() => {
          te(!1);
        }, 3e3)), V.current = k;
      }, [k, o]);
      const { refs: Q, floatingStyles: pe } = rt({
        strategy: "absolute",
        placement: "top-end",
        middleware: [
          nt(({ rects: P }) => ({
            alignmentAxis: -P.floating.width / 2
          })),
          at({ padding: 16 })
        ],
        whileElementsMounted: it
      }), G = se(null), X = C.number === 0, [ne, de] = Ae(0);
      ve(() => {
        if (!G.current)
          return;
        const P = () => {
          const B = G.current.getBoundingClientRect().width;
          B > 0 && de(B);
        };
        P();
        const A = new ResizeObserver(P);
        return A.observe(G.current), () => A.disconnect();
      }, [X, k]);
      const $ = i.tiers.filter((P) => P.shippingPrice > 0), E = $.reduce(
        (P, A, B) => C.number - w.number >= A.requiredCartAmount ? B : P,
        -1
      ), Y = Be(() => {
        const P = (B) => B < E ? B === 0 ? 40 : 32 : 50, A = $.reduce(
          (B, q, z) => B + (z === E ? 0 : P(z)),
          0
        );
        return $.map(
          (B, q) => q === E ? Math.max(0, ne - A) : P(q)
        );
      }, [ne, $, E]), he = Be(() => {
        if (E === -1)
          return 0;
        const P = Y.slice(0, E).reduce((u, d) => u + d, 0), A = i.tiers, B = $[E], q = A.findIndex(
          (u) => u.requiredCartAmount === B.requiredCartAmount
        ), z = A[q + 1], Z = B.requiredCartAmount, t = z ? z.requiredCartAmount : Z, e = C.number - w.number, s = Math.max(
          0,
          Math.min(1, (e - Z) / (t - Z))
        ), l = Y[E] || 0;
        return P + l * s;
      }, [
        Y,
        $,
        E,
        C,
        w,
        i.tiers
      ]);
      return /* @__PURE__ */ _(
        De,
        {
          className: p.wrapper,
          style: X ? { height: 0 } : void 0,
          children: !X && /* @__PURE__ */ ee(Je, { children: [
            /* @__PURE__ */ ee("div", { className: Xe(p.container, n), children: [
              /* @__PURE__ */ _(oe, { children: !k && /* @__PURE__ */ ee(
                R.div,
                {
                  initial: { y: -10, opacity: 0 },
                  animate: { y: 0, opacity: 1 },
                  exit: { y: -10, opacity: 0 },
                  transition: {
                    type: "spring",
                    stiffness: 300,
                    damping: 15,
                    mass: 0.5,
                    delay: 0.1
                  },
                  className: p.barometer,
                  children: [
                    /* @__PURE__ */ _("div", { className: p.steps, ref: G, children: $.map((P, A) => {
                      const B = A < E, q = A === E;
                      let z = f(P.shippingPrice);
                      if (q) {
                        const Z = i.tiers, t = Z[Z.findIndex(
                          (l) => l.requiredCartAmount === P.requiredCartAmount
                        ) + 1], e = Math.max(
                          0,
                          Math.ceil(
                            ((t == null ? void 0 : t.requiredCartAmount) ?? P.requiredCartAmount) - (C.number - w.number)
                          )
                        ), s = f(e);
                        z = (t == null ? void 0 : t.shippingPrice) === 0 ? b(
                          "Shipping_Barometer_Remaining_Free_Shipping",
                          { remainingAmount: s }
                        ) : b(
                          "Shipping_Barometer_Remaining_Amount",
                          { remainingAmount: s }
                        );
                      }
                      return /* @__PURE__ */ _(
                        ut,
                        {
                          setReference: Q.setReference,
                          shippingMethod: i.name,
                          shippingCost: f(P.shippingPrice),
                          icons: a,
                          isActive: q,
                          isCompleted: B,
                          label: z,
                          width: Y[A]
                        },
                        A
                      );
                    }) }),
                    /* @__PURE__ */ _(
                      R.div,
                      {
                        ref: Q.setReference,
                        className: p.progressBar,
                        animate: {
                          // x: `calc((100% - ${progressBarWidth}px) * -1)`,
                          width: `${he}px`
                        },
                        transition: {
                          type: "spring",
                          stiffness: 300,
                          damping: 20
                        }
                      }
                    ),
                    J && /* @__PURE__ */ _("div", { className: p.freeTier, children: b("Shipping_Barometer_Free_Label", {
                      shippingOptionName: i.name
                    }) })
                  ]
                },
                "barometer"
              ) }),
              /* @__PURE__ */ _(oe, { children: k && /* @__PURE__ */ _(
                R.div,
                {
                  initial: { y: 10, opacity: 0 },
                  animate: {
                    y: 0,
                    opacity: 1,
                    transition: {
                      delay: 0.3,
                      type: "spring",
                      stiffness: 300,
                      damping: 15,
                      mass: 0.5
                    }
                  },
                  exit: {
                    y: 10,
                    opacity: 0,
                    transition: {
                      delay: 0,
                      type: "spring",
                      stiffness: 300,
                      damping: 15,
                      mass: 0.5
                    }
                  },
                  className: p.freeMessage,
                  children: b("Shipping_Barometer_Free_Shipping_Reached")
                }
              ) }),
              T && /* @__PURE__ */ _(
                Vt,
                {
                  autorun: { speed: 4, duration: 1e3, delay: 500 }
                }
              )
            ] }),
            /* @__PURE__ */ _(
              "div",
              {
                ref: Q.setFloating,
                style: pe,
                className: "z-50 whitespace-nowrap",
                children: /* @__PURE__ */ _(oe, { children: E >= 0 && !k && /* @__PURE__ */ _(
                  R.span,
                  {
                    className: p.currentShippingCost,
                    initial: { scale: 0, y: 10, rotate: -2 },
                    animate: { scale: 1, y: 0, transition: { delay: 0.5 } },
                    exit: { scale: 0, y: 10 },
                    children: b("Shipping_Barometer_Step_Label", {
                      shippingMethod: i.name,
                      shippingCost: f(
                        $[E].shippingPrice
                      )
                    })
                  },
                  "floating"
                ) })
              }
            )
          ] })
        }
      );
    }
  )
), Gt = h.discriminatedUnion("template", [
  ke,
  ze
]), Yt = "template1", pr = ce(
  "ShippingBarometer",
  ue(
    {
      schema: Gt,
      defaultProps: { template: Yt }
    },
    (r) => r.template === "bouncy-steps" ? /* @__PURE__ */ _(st, { ...r }) : r.template === "template1" ? /* @__PURE__ */ _(Ht, { ...r }) : null
  )
), dr = [
  {
    shippingCost: "€30",
    shippingCostValue: 30,
    requiredCartAmount: 0
  },
  {
    shippingCost: "€20",
    shippingCostValue: 20,
    requiredCartAmount: 500
  },
  {
    shippingCost: "€10",
    shippingCostValue: 10,
    requiredCartAmount: 1e3
  },
  {
    shippingCost: "Free",
    shippingCostValue: 0,
    requiredCartAmount: 1500
  }
];
export {
  pr as ShippingBarometer,
  st as ShippingBarometerAsBouncySteps,
  ke as ShippingBarometerAsBouncyStepsSchema,
  Ht as ShippingBarometerTemplate1,
  ut as Template1Step,
  dr as mockData,
  pt as shippingBarometerOptionSchema,
  Gt as shippingBarometerSchema,
  ze as shippingBarometerTemplate1Schema
};
//# sourceMappingURL=index.es.js.map
